// Created by hejikun on 2017/10/25 0025.

let state = {
  ucenter_patient_list: [], // 就诊人列表
  ucenter_patient_list_new: [], // 新增就诊人列表
  ucenter_equal_patients: [], // 筛选合适的就诊人
  ucenter_address_list: [], // 收件人列表
  ucenter_patient_cards: [], // 就诊卡列表
  ucenter_my_follow_doctors: [], // 我关注的医生
  ucenter_my_follow_hospitals: [], // 我关注的医院
  ucenter_course_list: [], // 我的课堂
  ucenter_physicalExamination_list: [], // 我的体检列表
  ucenter_records_list: {
    list: []
  },
  ucenter_records_list1: {
    list: []
  },
  ucenter_menzhen_list: {
    list: []
  },
  ucenter_pay_list: [],
  ucenter_hasMore: false,
  ucenter_patient_id: 0,
  ucenter_health_card: '',
  ucenter_scheduleTimeType: {
    0: '未知',
    1: '上午',
    2: '下午',
    3: '中午',
    4: '晚上',
    5: '前夜',
    6: '后夜',
    7: '全天',
    8: '白天',
    9: '昼夜',
    10: '夜间',
    11: '傍晚',
    12: '傍晚'
  }
}

const actions = {
  loadUcenterDetail({ commit }, args) {
    let url = ''
    switch (args.type) {
      case '':
        url = ``
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        res.data.code === 1
          ? (() => {
              commit({
                type: 'set_ucenter_detail',
                dataType: args.type,
                data: res.data.data
              })
            })()
          : commit({
              type: 'set_ucenter_detail',
              dataType: args.type,
              data: {}
            })
        return Promise.resolve()
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  },
  loadUcenterList({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'ucenter_my_follow_doctors':
        url = `/ucenter/myfollow?user_id=${args.userId}&wechat_id=${args.wechatId}&type=${args.argType}&page=${args.page}`
        break
      case 'ucenter_pay_list':
        url = `/v1/payorder?openid=${args.openid}&num=10&page=${args.page}`
        break
      case 'ucenter_course_list':
        url = `/wxgroup/order?action=user_orders&page=${args.page}&wuser_id=${args.$wechat_id}`
        break
      case 'ucenter_physicalExamination_list':
        url = `/check/appoint?user_id=${args.user_id}&collection=${args.collection ? 1 : 0}${args.package_id ? '&package_id=' + args.package_id : ''}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        res && res.data && res.data.code === 1
          ? (() => {
              commit({
                type: 'set_ucenter_list',
                dataType: args.type,
                data: res.data.data,
                page: args.page
              })
            })()
          : commit({
              type: 'set_ucenter_list',
              dataType: args.type,
              data: [],
              page: args.page
            })
        return Promise.resolve()
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  },
  loadUcenterRegisterList({ commit }, args) {
    let url = ''
    let isOld = false
    if (args.type === 'ucenter_records_list') {
      if (args.hos_id) {
        isOld = true
        url = `/ucenter/myappoint?user_id=${args.user_id}&a_index=${args.a_index}&c_index=${args.c_index}&hos_id=${args.hos_id}&page_num=10&record_type=0`
      } else {
        isOld = true
        url = `/ucenter/myappoint?user_id=${args.user_id}&a_index=${args.a_index}&c_index=${args.c_index}&page_num=10&record_type=0`
      }
    } else if (args.type === 'ucenter_menzhen_list') {
      url = `/ucenter/mz?pindex=${args.pindex}&rindex=${args.rindex}&page_num=10&user_id=${args.user_id}`
    } else if (args.type === 'ucenter_records_list1') {
      if (args.hos_id) {
        url = `/ucenter/myappoint?user_id=${args.user_id}&a_index=${args.a_index}&c_index=${args.c_index}&hos_id=${args.hos_id}&page_num=10&record_type=0`
      } else {
        url = `/ucenter/myappoint?user_id=${args.user_id}&a_index=${args.a_index}&c_index=${args.c_index}&page_num=10&record_type=0`
      }
    } else {
      return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        res && res.data && res.data.code === 1
          ? (() => {
              let data = {}
              let aIndex = 1
              let cIndex = 1
              let pIndex = 1
              let rIndex = 1
              data.list = []
              res.data.data.list.forEach((value, index) => {
                // 因数据状态过多 解析状态
                if (value.order_id) {
                  if (value.his_status === 0) {
                    if (value.status !== -1) {
                      if (value.pay_status === 1 || value.pay_status === -1) {
                        value.register_status = 2
                      } else if (value.pay_status === 0) {
                        value.register_status = 1
                      } else {
                        value.register_status = 5
                      }
                    } else {
                      value.register_status = 3
                    }
                  } else {
                    value.register_status = 4
                  }
                }

                data.list.push(value)
              })
              aIndex = res.data.data.a_index
              cIndex = res.data.data.c_index
              pIndex = res.data.data.pindex
              rIndex = res.data.data.rindex
              res.data.data = data
              res.data.data.a_index = aIndex
              res.data.data.c_index = cIndex
              res.data.data.pindex = pIndex
              res.data.data.rindex = rIndex

              commit({
                type: 'set_ucenter_register_list',
                data: res.data.data,
                dataType: args.type,
                user_id: args.user_id,
                page_num: args.page_num
              })
            })()
          : commit({
              type: 'set_ucenter_register_list',
              data: [],
              dataType: args.type,
              a_index: args.a_index,
              c_index: args.c_index,
              user_id: args.user_id,
              page_num: args.page_num
            })
        return Promise.resolve()
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  }
}

const getters = {
  ucenter_patient_detail(state) {
    let detail = []
    detail = state.ucenter_patient_list.filter((item) => {
      return state.ucenter_patient_id === item.id
    })
    if (state.ucenter_patient_list_new) {
      detail = state.ucenter_patient_list_new.filter((item) => {
        return state.ucenter_patient_id === item.id
      })
    }
    return detail[0] || {}
  },
  // 默认就诊人
  ucenter_patient_default(state) {
    let pats = []
    pats = state.ucenter_patient_list.filter((pat) => {
      return pat.card_type === 1 && pat.patient_relation === 1
    })
    if (state.ucenter_patient_list_new) {
      pats = state.ucenter_patient_list_new.filter((pat) => {
        return pat.card_type === 1 && pat.patient_relation === 1
      })
    }
    return pats[0] || {}
  }
}

const mutations = {
  set_ucenter_patient_id_new(state, arg) {
    state.ucenter_patient_id = arg
  },
  set_ucenter_health_card(state, arg) {
    state.ucenter_health_card = arg
  },
  set_ucenter_detail(state, args) {
    state[args.dataType] = args.data
  },
  set_ucenter_list(state, args) {
    let data = args
    if (data.dataType === 'ucenter_course_list') {
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].teacher.split(' ') !== '') {
          data.data[i].teacher = data.data[i].teacher.split(' ')
        }
      }
    }
    data.data.length < 10 ? (state.ucenter_hasMore = false) : (state.ucenter_hasMore = true)
    if (data.page === 1) {
      if (data.data.length==0) {
        state[data.dataType] = []
      } else {
        state[data.dataType] = data.data
      }
    } else {
      if (args.data.length !== 0) {
        args.data.forEach((item) => {
          state[args.dataType].push(item)
        })
      }
    }
  },
  set_ucenter_register_list(state, args) {
    args.data.list.length < 10 ? (state.ucenter_hasMore = false) : (state.ucenter_hasMore = true)
    if (args.data.pindex) {
      if (args.data.pindex === 1 && args.data.rindex === 1) {
        if (args.data.list.length == 0) {
          state[args.dataType] = {
            list:[]
          }
        } else {
          state[args.dataType].list = args.data.list
          state[args.dataType].pindex = args.data.pindex
          state[args.dataType].rindex = args.data.rindex
        }
      } else {
        if (args.data.list.length !== 0) {
          state[args.dataType].pindex = args.data.pindex
          state[args.dataType].rindex = args.data.rindex
          args.data.list.forEach((item) => {
            state[args.dataType].list.push(item)
          })
          console.log(state[args.dataType],321)
        }
      }
      return
    }
    if (args.data.a_index === 1 && args.data.c_index === 1) {
      if (args.data.list.length == 0) {
        state[args.dataType] = {}
      } else {
        state[args.dataType].list = args.data.list
        state[args.dataType].a_index = args.data.a_index
        state[args.dataType].c_index = args.data.c_index
      }
    } else {
      if (args.data.list.length !== 0) {
        state[args.dataType].a_index = args.data.a_index
        state[args.dataType].c_index = args.data.c_index
        args.data.list.forEach((item) => {
          state[args.dataType].list.push(item)
        })
      }
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
